import Promise from 'promise-polyfill';
import polyfills from './polyfill-registry';

window.Promise = window.Promise || Promise;

export const polyfillsAreInstalled = (function installPolyfills() {
    const polyfillPromises = [];

    polyfills.forEach(({ test, polyfill }) => {
        if (test()) {
            polyfillPromises.push(new Promise(polyfill));
        }
    });

    return Promise.all(polyfillPromises);
}());

export const handleErrors = (err) => {
    setTimeout(() => {
        if (err instanceof Error) {
            throw err;
        } else {
            console.warn(err);
        }
    });
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/util/polyfills/index.js